//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var geolocation = new qq.maps.Geolocation("T7SBZ-OJTL3-2PU3S-YHABH-GYHJK-FVFXQ", "HFB-hui-yuan-duan");
export default{
	name: "daolujiuyuan",
	data(){
		return{
      daolujiuyuanList: [
        {}
      ],
      sid: "",
      popup: false,
      name: "",
      tel: "",
      remark: "",
      catchLat: "",
      catchLng: "",
      addr: ""
		}
	},
  methods:{
    onScrollBottom(){

    },
    call(tel){
      window.location.href = "tel://" + tel;
    },
    send(sid){
      this.sid = sid;
      this.name = "",
      this.tel = "",
      this.remark = "";
      this.popup = true;
    },
    enterSend(){
      this.$HTTP.HttpPost("/member/rescue/sendRescue",
      {longitude: this.catchLng,
      latitude: this.catchLat,
      address: this.addr,
      contact_name: this.name,
      member_remark: this.remark,
      tel: this.tel})
      .then((data)=>{
        this.$vux.toast.show({
          text: data.data.msg,
          type: "text",
          width: "80%",
          isShowMask: true
        })
        this.popup = false;
      })
    }
  },
  mounted(){
    this.$HTTP.HttpPost("/member/rescue/getStoreList", {})
    .then((data)=>{
      this.daolujiuyuanList = data.data.data;
      geolocation.getLocation(
      (msg)=>{
        this.remark = msg.province + msg.city + msg.district + msg.addr;
        this.catchLat = msg.lat;
        this.catchLng = msg.lng;
        this.addr = msg.addr;
        let start = 0;
        let end = 0;
        let distance = 0;
        for(let i in this.daolujiuyuanList){
          start = new qq.maps.LatLng(this.catchLat, this.catchLng);
          end = new qq.maps.LatLng(this.daolujiuyuanList[i].latitude, this.daolujiuyuanList[i].longitude);
          distance = Math.round(qq.maps.geometry.spherical.computeDistanceBetween(start, end)*1)/1000;
          this.daolujiuyuanList[i].distance = distance;
        }
      },
      (msg)=>{
        this.$vux.toast.show({
          text: "定位失败 请打开定位刷新重试",
          type: "text",
          width: "80%",
          isShowMask: true
        })
      });
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/daolujiuyuan.vue